import { render } from "./OurImpact.vue?vue&type=template&id=784c7079&scoped=true"
import script from "./OurImpact.vue?vue&type=script&lang=js"
export * from "./OurImpact.vue?vue&type=script&lang=js"

import "./OurImpact.vue?vue&type=style&index=0&id=784c7079&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784c7079"]])

export default __exports__